export default __webpack_public_path__ + "static/Dr.RanjanKWadhwa-308e5dbade1e284487a23b0e9f087ffc.png";